import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Component from './component'
import Callbacks from './callbacks'

const JobContainer = (props) => {
  const setFormValues = hooks.useFormChange()

  const [, searchJob] = hooks.useModelSearch('job', 'get', {
    single: true,
    populate: [
      'first_step.order.driver_opts',
      'first_step.order.vehicle_opts',
      'first_step.order.source',
      'first_step.order.service.contract.company',
      'first_step.order.commercial_package.vehicletypes'
    ]
  })

  const afterChangeJob = useCallback(Callbacks.afterChangeJobHandler(setFormValues, searchJob), [setFormValues, searchJob])

  const mergedProps = {
    afterChangeJob
  }

  return (
    <Component {...mergedProps} />
  )
}

export default JobContainer
